export default "__VITE_ASSET__CYA91V6V__"